import { getAreaId } from "../../helpers";
export default function (store, { id, columnId, rowId, before, source, dragItemsCoords, dropAreasCoords, }) {
    const { areasMeta, cardsMeta, layout } = store.getState();
    dropAreasCoords?.forEach(area => {
        if (area.id) {
            areasMeta[area.id].height =
                layout !== "default:lazy" ? area.height : null;
        }
    });
    const draggedCards = [...source];
    draggedCards.forEach(id => {
        const meta = cardsMeta[id] || {};
        meta.dragging = true;
        cardsMeta[id] = meta;
    });
    const overAreaId = getAreaId(columnId, rowId);
    store.setState({
        dragItemId: id,
        dragItemsCoords,
        overAreaId,
        before,
        areasMeta,
        cardsMeta,
    });
}
//# sourceMappingURL=start.js.map